'use client';

import Script from 'next/script';
import type { CasperResponseCookies } from '@lmn/nextjs-appfw/dist/casper';

type ClientSideCasperCookieSetterProps = {
  casperResponseCookies: CasperResponseCookies | undefined;
};
export const ClientSideCasperCookieSetter = ({ casperResponseCookies }: ClientSideCasperCookieSetterProps) => {
  if (!casperResponseCookies) return null;

  const cookieEntries = Object.entries(casperResponseCookies);

  const scriptContent = `
    function setCookie({ name, value, maxAge, domain, path, httpOnly }) {
      let cookieStr = encodeURIComponent(name) + "=" + encodeURIComponent(value);
      
      if (maxAge) cookieStr += "; max-age=" + maxAge;
      if (domain) cookieStr += "; domain=" + domain;
      if (path) cookieStr += "; path=" + path;
      else cookieStr += "; path=/"; // Default path

      // httpOnly is ignored client-side; included here for clarity but not usable
      document.cookie = cookieStr;
    }

    ${cookieEntries.map(([, cookie]) => `setCookie(${JSON.stringify(cookie)});`).join('\n')}
  `;

  return (
    <Script id="set-client-cookies" strategy="beforeInteractive" dangerouslySetInnerHTML={{ __html: scriptContent }} />
  );
};
